import { InjectionToken } from '@angular/core';

export const PORTAL_NAME = new InjectionToken<string>('PORTAL_NAME');
